import util from '@bmp-vue/core/api/util'
const controller = 'Digicash'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Taxas: [
    { value: 1.69, text: '1,69%' },
    { value: 1.79, text: '1,79%' },
    { value: 1.89, text: '1,89%' },
    { value: 1.99, text: '1,99%' }
  ]
})
